import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { business } from '../data/business';
import { SiteFooter } from '../components/SiteFooter';
export function Privacy() {
  return <div className="min-h-screen w-full bg-ivory-50 font-sans text-graphite-900" data-id="element-207" data-mp="3b9cxlcjajvml">
      <main className="mx-auto max-w-3xl px-5 py-16 lg:px-8 lg:py-24" data-id="element-208" data-mp="36hl0sk9jkto0">
        <Link to="/" className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-emerald-700 hover:text-gold-600" data-id="element-209" data-mp="3k8zmwzyqxaza">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-210" data-mp="3fciye4nmwulo" />
          Volver al inicio
        </Link>

        <h1 className="mt-8 font-display text-3xl font-semibold text-emerald-900 sm:text-4xl" data-id="element-211" data-mp="3p8ckaen8u0g4">
          Política de Privacidad
        </h1>
        <p className="mt-4 text-sm text-graphite-700/80" data-id="element-212" data-mp="1zufrsqyw0rsj">
          {business.brand} — {business.legalName}
        </p>

        <div className="mt-10 space-y-10 text-sm leading-relaxed text-graphite-700" data-id="element-213" data-mp="1uvw6mss4bk18">
          <section data-id="element-214" data-mp="h3h3bwcmu4vw">
            <h2 className="font-display text-xl font-semibold text-emerald-900" data-id="element-215" data-mp="h40lne672vag">
              1. Información que recibimos
            </h2>
            <p className="mt-4" data-id="element-216" data-mp="q346aml0fir2">
              Recibimos únicamente la información que cada persona comparte de
              forma voluntaria al comunicarse con nosotros: nombre, número de
              teléfono o WhatsApp y los datos que decida mencionar durante la
              consulta.
            </p>
          </section>

          <section data-id="element-217" data-mp="14qpbqn5cxu25">
            <h2 className="font-display text-xl font-semibold text-emerald-900" data-id="element-218" data-mp="14q77b38jk9j5">
              2. Uso de la información
            </h2>
            <p className="mt-4" data-id="element-219" data-mp="1dsgblbd7v6o3">
              La información se utiliza exclusivamente para atender la consulta
              y mantener la comunicación solicitada. No se vende ni se cede a
              terceros con fines comerciales.
            </p>
          </section>

          <section data-id="element-220" data-mp="3flw4yg0ouzmr">
            <h2 className="font-display text-xl font-semibold text-emerald-900" data-id="element-221" data-mp="mpbfl79i67vl">
              3. Confidencialidad
            </h2>
            <p className="mt-4" data-id="element-222" data-mp="hr064xn4dzdw">
              Cada consulta se trata con privacidad y discreción. El contenido
              de las conversaciones no se comparte públicamente.
            </p>
          </section>

          <section data-id="element-223" data-mp="qpveogdmzlkd">
            <h2 className="font-display text-xl font-semibold text-emerald-900" data-id="element-224" data-mp="qplj8d9tom7a">
              4. Edad mínima
            </h2>
            <p className="mt-4" data-id="element-225" data-mp="15luk1j9d37lt">
              El servicio está dirigido exclusivamente a personas mayores de
              edad (18 años o más).
            </p>
          </section>

          <section data-id="element-226" data-mp="1eilke7uy58m7">
            <h2 className="font-display text-xl font-semibold text-emerald-900" data-id="element-227" data-mp="1aevxdmtx6z3a">
              5. Cookies y herramientas de medición
            </h2>
            <p className="mt-4" data-id="element-228" data-mp="1ofgkgv6vbh2l">
              [Completar indicando si el sitio utiliza cookies, analítica o
              herramientas publicitarias, y con qué finalidad.]
            </p>
          </section>

          <section data-id="element-229" data-mp="231x18oibfupv">
            <h2 className="font-display text-xl font-semibold text-emerald-900" data-id="element-230" data-mp="22zatoovfdf7n">
              6. Ejercicio de derechos y contacto
            </h2>
            <p className="mt-4" data-id="element-231" data-mp="1t3zek5g3u5zd">
              Para solicitar la eliminación o corrección de tus datos puedes
              comunicarte al {business.phone} o escribirnos por WhatsApp al{' '}
              {business.whatsapp}.
            </p>
          </section>
        </div>
      </main>
      <SiteFooter data-id="element-232" data-mp="1p24fz8pk66pa" />
    </div>;
}